import React from 'react';
import PropTypes from 'prop-types';
import _get from 'lodash/get';
import ItemCard from './ItemCard';


const ItemCardsWrapper = props => (
  <div className="itemCardsWrapper">
    <div className="itemCards">
      {props.itemIds.map((id, index) =>
          (<ItemCard
            containerId={props.containerId}
            itemId={id}
            key={id}
            itemIndex={index + 1}
            isValidCopyStyles={_get(props.copyStyles, `validationResults[${id}]`, { isValid: true, errors: [] })}
          />))}
    </div>
  </div>
);

ItemCardsWrapper.propTypes = {
  copyStyles: PropTypes.shape({}).isRequired,
  containerId: PropTypes.string.isRequired,
  itemIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ItemCardsWrapper;
